// extracted by mini-css-extract-plugin
export default {"layout":"MainLayout_layout__wVrc4","main":"MainLayout_main__0ptyv","collapsed":"MainLayout_collapsed__v4wC1"};